import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  makeStyles,
} from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHourglassClock } from '@fortawesome/duotone-regular-svg-icons';
import { Button, BoxV2 as Box } from 'portal-commons';

interface RcsVetSuccessModalProps {
  open: boolean;
  onClose: () => void;
}

const useStyles = makeStyles(() => ({
  container: {
    width: '525px',
    maxWidth: 'unset',
    padding: '26px 6px 30px 6px',
    boxSizing: 'border-box',
    lineHeight: 'normal',
    textAlign: 'center',
  },
  actions: {
    justifyContent: 'center',
  },
}));

const RcsVetSuccessModal: React.FC<RcsVetSuccessModalProps> = ({
  open,
  onClose,
}) => {
  const classes = useStyles();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      disableBackdropClick
      classes={{
        paper: classes.container,
      }}
    >
      <DialogContent>
        <FontAwesomeIcon
          icon={faHourglassClock}
          className="fa-regular"
          fontSize="64"
          color="#0091B3"
        />

        <Box as="p" sx={{ color: '#000', fontSize: '16px', mt: 'l', mb: 'xl' }}>
          We are confirming your data with the Vetting Partner. Please come back
          later to check on the status of the request.
        </Box>
      </DialogContent>
      <DialogActions classes={{ root: classes.actions }}>
        <Button
          data-testid="closeButton"
          onClick={onClose}
          variant="standard"
          size="medium"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RcsVetSuccessModal;
